import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { Dictionary, DictionaryItem, DictionaryType } from '../../../../domain/dictionary.model';
import { ValidationError } from '../../../../domain/error.model';
import { ManualVehicleData, VehicleDefinition } from '../../../../domain/product.domain';
import { LsnErrorStateMatcher } from '../../../shared/middleware/error-state-matcher';
import { FlexFilterPipe } from '../../../shared/pipe/flex-filter.pipe';
import { DictionaryState } from '../../store/dictionary.state';
import { ErrorsState } from '../../store/errors.state';

@Component({
    selector: 'app-car-manual-form',
    templateUrl: './car-manual-form.component.html',
    styleUrls: ['./car-manual-form.component.scss']
})
export class CarManualFormComponent implements OnInit, OnDestroy {

    @Input() title: string = null;
    @Input() prefix: string = null;
    @Input() data: VehicleDefinition;
    @Input() aside: boolean = true


    subscriptions: Subscription[] = [];
    errors: ValidationError[] = [];

    matchers: any;

    @Select(ErrorsState.getMainErrors) mainErrors$: Observable<ValidationError[]>;
    @Select(ErrorsState.getAsideErrors) asideErrors$: Observable<ValidationError[]>;
    @Select(DictionaryState.getDictionaries) dictionaries$: Observable<{ [key: string]: Dictionary }>;
    dictionaryTypes = DictionaryType;

    constructor(private flexFilter: FlexFilterPipe, private store: Store) {
    }

    set type($event: any) {
        this.data.manual.type = {code: $event};
        if ($event === null) {
            this.data.manual.make = null;
            this.data.manual.fuelType = {code: null};
            this.data.manual.bodyType = {code: null};
            return;
        }

        const dictionaries = this.store.selectSnapshot(DictionaryState.getDictionaries);
        if (!this.existsInDictionary(dictionaries[this.dictionaryTypes.VEHICLE_FUEL_TYPE], $event, DictionaryItem.getCode(this.data.manual.fuelType))) {
            this.data.manual.fuelType = {code: null};
        }
        if (!this.existsInDictionary(dictionaries[this.dictionaryTypes.VEHICLE_BODY_TYPE], $event, DictionaryItem.getCode(this.data.manual.bodyType))) {
            this.data.manual.bodyType = {code: null};
        }
    }

    private existsInDictionary(dictionary: Dictionary, make, value) {
        const filtered = this.flexFilter.transform(dictionary.itemList, make);
        return !!filtered.find(e => e.code === value);
    }

    ngOnInit(): void {
        if (this.data.manual === null) {
            this.data.manual = new ManualVehicleData();
        }

        this.subscriptions.push(
            this.aside
                ? this.asideErrors$.subscribe(errors => this.errors = errors)
                : this.mainErrors$.subscribe(errors => this.errors = errors)
        );

        this.prepareMatchers();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    private prepareMatchers() {
        const merge = value => this.prefix !== null
            ? `${this.prefix}.${value}`
            : value;

        this.matchers = {
            productionYear: new LsnErrorStateMatcher(this, merge('productionYear')),
            manual: {
                type: new LsnErrorStateMatcher(this, merge('manual.type')),
                productionYear: new LsnErrorStateMatcher(this, merge('manual.productionYear')),
                make: new LsnErrorStateMatcher(this, merge('manual.make')),
                model: new LsnErrorStateMatcher(this, merge('manual.model')),
                bodyType: new LsnErrorStateMatcher(this, merge('manual.bodyType')),
                doors: new LsnErrorStateMatcher(this, merge('manual.doors')),
                fuelType: new LsnErrorStateMatcher(this, merge('manual.fuelType')),
                version: new LsnErrorStateMatcher(this, merge('manual.version')),
                engineCapacity: new LsnErrorStateMatcher(this, merge('manual.engineCapacity')),
                enginePower: new LsnErrorStateMatcher(this, merge('manual.enginePower')),
                loadCapacity: new LsnErrorStateMatcher(this, merge('manual.loadCapacity')),
                maximumWeight: new LsnErrorStateMatcher(this, merge('manual.maximumWeight')),
            }
        };
    }


}
